export default "__VITE_IMAGE_ASSET__9119c104__";